// Styles
import styles from './VideoModal.module.css';

// Icons
import CloseIcon from "@mui/icons-material/Close";

/**
 * VideoModal Component: Shows the video options in the category body
 * @param {string} videoLink - videoLink to show
 * @param {string} title - title
 * @returns {JSX } - Returns the video options in a list format
 */
const VideoModal = ({ videoLink, title, clickHandler }) => {
  return (
    <div
      className={styles.overlay}
      onClick={clickHandler}
    >
      <div className={styles.modal_wrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modal_header}>
          <span>{title}</span>
          <button
            className={styles.close_btn}
            onClick={clickHandler}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.video_wrapper}>
          <iframe
            title={title}
            width="100%"
            height="100%"
            src={videoLink}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
